import { Trans, useLingui } from "@lingui/react/macro";
import { observer } from "mobx-react-lite";
import { useState } from "react";

import { apiGetHfSymptomsPatientId } from "../../../api";
import { AppModel } from "../../../app/app-model";
import { AddButton } from "../../../components/ui-kit/add-button";
import { SymptomPlotModel } from "../../../models/plotting";
import { useFetch } from "../../../utils/use-fetch";
import { PatientSubpage } from "../common/patient-subpage";
import { PlotCanvas, PlotControls, usePlot } from "../common/plot";
import { AddSymptomsDialog } from "./add-symptoms-dialog";
import { Symptoms, SymptomsItem } from "./symptoms";
import { SymptomsTable } from "./symptoms-table";

export const SymptomsRoute = observer(function SymptomsRoute(props: {
  app: AppModel;
}) {
  const { t } = useLingui();
  const patient = props.app.requirePatient();
  const api = props.app.seerlinqApi;
  const [model] = useState(
    () => new Symptoms([], api.permissions, api.requireUserUUID()),
  );

  const [data, setData] = useState<SymptomsItem[]>([]);
  const [showAddDialog, setShowAddDialog] = useState(false);

  const { loading, refetch } = useFetch(
    async ({ isRefetch }) => {
      const response = await apiGetHfSymptomsPatientId({
        path: { patient_id: patient.patientId },
        meta: { useSessionCache: !isRefetch },
      });
      model.updateData(response.data.symptoms);
      setData(response.data.symptoms);
    },
    [patient.patientId],
  );

  const plot = usePlot(
    () =>
      new SymptomPlotModel(
        model,
        ["shortness of breath", "fatigue score"],
        "plot-canvas",
      ),
  );

  return (
    <PatientSubpage title={t`Symptoms`} loading={loading}>
      <PlotCanvas model={plot} />

      <SymptomsTable
        filterActions={
          <>
            <AddButton onClick={() => setShowAddDialog(true)}>
              <Trans>Add symptoms</Trans>
            </AddButton>
            <PlotControls model={plot} />
          </>
        }
        api={api}
        data={data}
        onInvalidated={refetch}
        patient={patient}
        persistState
      />

      {showAddDialog && (
        <AddSymptomsDialog
          app={props.app}
          onClose={() => setShowAddDialog(false)}
          onSaved={refetch}
        />
      )}
    </PatientSubpage>
  );
});
